import { isEmpty } from 'lodash-es';
import { DataSourcesQueries } from '@frontend/api-data-sources';
import { useScopedAppFlagStore } from '@frontend/scope';
import { useAppFlagStore } from '@frontend/shared';
import { useLocalStorage } from '@frontend/web-storage';

const LOCALSTORAGE_KEY = 'weave.schedule-waitlist';
const FF_NAME = 'schedule:waitlist';

const useFFOverride = () => {
  const [isFFOverride] = useLocalStorage({
    key: LOCALSTORAGE_KEY,
    // Note: need to keep it like this as for initial cases, we receive false even if value is set to true
    defaultValue: localStorage.getItem(LOCALSTORAGE_KEY) === 'true',
  });

  return { isOverrideFF: !!isFFOverride };
};

export const useGetWaitlistFeatureFlagDetails = () => {
  const { isOverrideFF } = useFFOverride();
  const { featureFlags } = useAppFlagStore();
  const isFeatureFlagsLoaded = !isEmpty(featureFlags);

  const { getFeatureFlagValue } = useScopedAppFlagStore();
  const { isIntegratedOffice, isLoading: isLoadingIntegrationDetails } =
    DataSourcesQueries.useGetAccessibleIntegrations();

  // NOTE: Remove this temporary check(isFeatureFlagsLoaded) later once this logic added into `getFeatureFlagValue` method
  const hasFF = isFeatureFlagsLoaded && getFeatureFlagValue(FF_NAME, 'ALL');
  const isLoading = !isFeatureFlagsLoaded || isLoadingIntegrationDetails;

  return {
    isLoading,
    isWaitlistFFEnabled: (!isLoading && hasFF && !isIntegratedOffice) || isOverrideFF,
  };
};
